const SIDE_ROOM = 100
const BELOW_ROOM = 36

/** Side when the reading pane has a margin. Otherwise under the hunk, or above if that would leave the pane. */
export function placeReviewChips(scroller: HTMLElement) {
  const scrollerRect = scroller.getBoundingClientRect()
  scroller.querySelectorAll('.group\\/hunk').forEach((node) => {
    if (!(node instanceof HTMLElement)) return
    const rect = node.getBoundingClientRect()
    const roomRight = scrollerRect.right - rect.right
    const roomBelow = scrollerRect.bottom - rect.bottom
    const next = roomRight >= SIDE_ROOM ? 'side' : roomBelow < BELOW_ROOM ? 'above' : 'below'
    if (node.dataset.chipPlace !== next) node.dataset.chipPlace = next
  })
}
